var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#FFA800",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5018 47.0002C38.2705 47.0002 47.0003 38.2703 47.0003 27.5014C47.0003 16.7326 38.2705 8.00269 27.5018 8.00269C16.7332 8.00269 8.00342 16.7326 8.00342 27.5014C8.00342 38.2703 16.7332 47.0002 27.5018 47.0002Z",
    fill: "url(#paint0_linear_2038_666)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5017 44.823C37.0682 44.823 44.8233 37.0678 44.8233 27.5012C44.8233 17.9346 37.0682 10.1793 27.5017 10.1793C17.9353 10.1793 10.1802 17.9346 10.1802 27.5012C10.1802 37.0678 17.9353 44.823 27.5017 44.823Z",
    fill: "url(#paint1_linear_2038_666)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7905 21.2042L35.5165 16.3951L39.0563 15.9391L38.6029 19.481L33.7905 21.2042ZM35.9094 16.8838L34.6799 20.3275L38.1115 19.0981L38.4365 16.579L35.9094 16.8838Z",
    fill: "#D8642D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7492 16.2539L34.2393 20.7658L38.3612 19.287L38.7492 16.2539Z",
    fill: "url(#paint2_linear_2038_666)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7492 16.2539L34.2393 20.7658L35.7182 16.6444L38.7492 16.2539Z",
    fill: "#FFF473"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.61
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7487 16.2539L35.7354 16.6419L38.3632 19.2694L38.7487 16.2539Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7386 18.0123L35.7358 16.6419L38.7492 16.2539L34.2393 20.7658L36.7386 18.0123Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1554 33.8405L19.432 38.6521L15.8896 39.1055L16.3456 35.5787L21.1554 33.8405ZM19.0365 38.1608L20.2685 34.7297L16.8345 35.949L16.512 38.4682L19.0365 38.1608Z",
    fill: "#D8642D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1968 38.7931L20.7067 34.2813L16.5848 35.76L16.1968 38.7931Z",
    fill: "#FFF473"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1968 38.7931L20.7067 34.2813L19.2303 38.4027L16.1968 38.7931Z",
    fill: "url(#paint3_linear_2038_666)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M16.1968 38.7934L19.2101 38.4055L16.5823 35.778L16.1968 38.7934Z",
    fill: "#D8642D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 34.324L17.87 36.818L16.5825 35.7776L17.8977 37.0901L20.6641 34.324Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4225 21.1587L16.6103 19.4356L16.1567 15.8936L19.684 16.3471L21.4225 21.1587ZM17.099 19.0401L20.5331 20.2695L19.3011 16.8383L16.7816 16.5134L17.099 19.0401Z",
    fill: "#D8642D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4692 16.201L20.9817 20.7104L19.5027 16.589L16.4692 16.201Z",
    fill: "#FFF473"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4692 16.201L20.9817 20.7104L16.8598 19.2341L16.4692 16.201Z",
    fill: "url(#paint4_linear_2038_666)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M16.4692 16.201L16.8547 19.2165L19.4851 16.5865L16.4692 16.201Z",
    fill: "#FFF473"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3412 17.8889L19.5153 16.6218L18.1825 17.7327L16.4692 16.201L20.9817 20.7104L18.3412 17.8889Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6607 35.3115L39.1142 38.8384L35.5818 38.4L33.856 33.5859L38.6607 35.3115ZM38.4944 38.2312L38.1694 35.7121L34.7378 34.4802L35.9673 37.9138L38.4944 38.2312Z",
    fill: "#D8642D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8068 38.5387L34.2969 34.0293L38.4188 35.5056L38.8068 38.5387Z",
    fill: "#FFF473"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8068 38.5387L34.2969 34.0293L35.7733 38.1507L38.8068 38.5387Z",
    fill: "url(#paint5_linear_2038_666)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M38.8068 38.539L35.7935 38.1535L38.4213 35.5235L38.8068 38.539Z",
    fill: "#D8642D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1187 36.6669L38.3885 35.4955L37.2774 36.8256L38.8068 38.5387L34.2969 34.0293L37.1187 36.6669Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5043 7.99997L8.00342 27.4987L10.2961 29.794L27.5043 47L44.7076 29.794L47.0002 27.4987L27.5043 7.99997ZM11.3619 28.7283L10.1752 27.5466L10.1299 27.4987L17.0938 20.5372L17.1139 20.5196L26.6503 10.9806L27.5043 10.1265L27.5825 10.2071L44.8764 27.4987L44.7201 27.6549L43.6467 28.7283L27.5825 44.7928L27.5043 44.8735L11.3619 28.7283Z",
    fill: "#DE6228"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5898 9.06959L9.1543 27.5054L27.5899 45.9413L46.0254 27.5054L27.5898 9.06959Z",
    fill: "url(#paint6_linear_2038_666)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5852 9.06305V12.1873L12.1835 27.6371L9.14746 27.5011L27.5852 9.06305Z",
    fill: "white"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4689 10.8924C26.8469 10.5271 26.678 12.4671 26.217 12.7443C25.7559 13.0214 14.4081 25.1984 13.7958 24.8104C13.1836 24.4223 21.4576 15.7375 26.4689 10.8924Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0202 27.5012L42.9262 27.8741L27.585 43.1803V45.9367L46.0202 27.5012Z",
    fill: "#FF771E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5025 11.996L11.9976 27.5012L27.5024 43.0063L43.0074 27.5011L27.5025 11.996Z",
    fill: "url(#paint7_linear_2038_666)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3848 27.3602L17.6127 27.6424L27.6429 37.1083L18.3711 27.5189L27.7487 18.1412L37.3908 27.3602L27.9603 17.2946L27.6429 12.1018L27.2549 17.9295L18.1066 27.078L12.3848 27.3602Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M27.4931 18.0875L18.4238 27.1568L27.4931 36.2262L36.5623 27.1568L27.4931 18.0875Z",
    fill: "url(#paint8_linear_2038_666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M28.0161 14.2812L28.2605 18.0277L36.789 26.5564L40.8051 27.0729L28.0161 14.2812Z",
    fill: "url(#paint9_linear_2038_666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M14.4712 27.8262L18.2177 28.0731L26.7462 36.5993L27.2627 40.6154L14.4712 27.8262Z",
    fill: "url(#paint10_linear_2038_666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.25,
    d: "M40.7241 27.9069L36.9776 28.1538L28.4516 36.6799L27.9326 40.6986L40.7241 27.9069Z",
    fill: "url(#paint11_linear_2038_666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M26.9902 14.1729L26.9348 18.1084L18.4088 26.637L14.1987 26.9646L26.9902 14.1729Z",
    fill: "url(#paint12_linear_2038_666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.53,
    d: "M24.4153 21.6282L32.4097 23.0341L36.5467 27.1712L21.8529 24.4551L32.3996 31.3209L29.0789 34.6391L20.0439 25.9971L24.4153 21.6282Z",
    fill: "url(#paint13_linear_2038_666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M18.6181 27.8238C18.6181 27.8238 21.702 32.1977 26.4009 27.8238C29.6762 24.7827 36.0733 27.2645 36.0733 27.2645C36.0733 27.2645 27.7589 19.3531 27.5221 19.2548C27.2852 19.1566 17.4843 27.8868 18.6181 27.8238Z",
    fill: "url(#paint14_linear_2038_666)"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5017 38.3782L16.625 27.5013L27.5017 16.6219L38.3809 27.5013L27.5017 38.3782ZM17.333 27.5013L27.5017 37.6702L37.6704 27.5013L27.5017 17.3324L17.333 27.5013ZM27.5017 37.2293L17.7739 27.5013L27.5017 17.7708L37.232 27.5013L27.5017 37.2293ZM18.4818 27.5013L27.5017 36.5213L36.5241 27.5013L27.5017 18.4788L18.4818 27.5013Z",
    fill: "#D8642D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5019 16.9771L16.9805 27.5012L27.5019 38.0228L38.0259 27.5012L27.5019 16.9771ZM18.1269 27.5012L27.5019 18.1234L36.877 27.5012L27.5019 36.8764L18.1269 27.5012Z",
    fill: "url(#paint15_linear_2038_666)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4944 18.5643L25.3125 13.941L27.4944 11.1166L29.6763 13.941L27.4944 18.5643ZM25.9373 14.009L27.4944 17.3046L29.0515 14.0065L27.4944 11.9909L25.9373 14.009Z",
    fill: "#D8642D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4995 11.5576V17.9386L29.369 13.9785L27.4995 11.5576Z",
    fill: "url(#paint16_linear_2038_666)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4994 11.5576V17.9386L25.6299 13.9785L27.4994 11.5576Z",
    fill: "#FFF473"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.61
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4994 11.5576L25.6426 13.9634H29.3588L27.4994 11.5576Z",
    fill: "white"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3206 14.2228L25.6426 13.9634L27.4994 11.5576V17.9386L27.3206 14.2228Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4944 36.433L29.6763 41.0564L27.4944 43.8808L25.3125 41.0564L27.4944 36.433ZM29.0515 40.9884L27.4944 37.6903L25.9373 40.9884L27.4944 43.004L29.0515 40.9884Z",
    fill: "#D8642D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4892 43.4414V37.0629L25.6172 41.023L27.4892 43.4414Z",
    fill: "#FFF473"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4893 43.4414V37.0629L29.3587 41.023L27.4893 43.4414Z",
    fill: "url(#paint17_linear_2038_666)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M27.4893 43.442L29.3461 41.0387H25.6299L27.4893 43.442Z",
    fill: "#D8642D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4893 37.1233L27.2751 40.8618L25.6299 41.0381H27.4893V37.1233Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7142 27.2792L14.0934 29.4633L11.269 27.2792L14.0934 25.0976L18.7142 27.2792ZM14.1665 28.8361L17.4645 27.2792L14.1665 25.7223L12.1509 27.2792L14.1665 28.8361Z",
    fill: "#D8642D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.707 27.2741H18.0864L14.1258 25.4049L11.707 27.2741Z",
    fill: "#FFF473"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M11.707 27.2745H18.0864L14.1258 29.1438L11.707 27.2745Z",
    fill: "url(#paint18_linear_2038_666)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M11.707 27.2741L14.1106 29.1333V25.4175L11.707 27.2741Z",
    fill: "#FFF473"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.224 27.1456L14.156 25.42L13.9998 27.1456L11.707 27.2741H18.0864L14.224 27.1456Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9133 25.0976L43.7377 27.2792L40.9133 29.4633L36.29 27.2792L40.9133 25.0976ZM42.8583 27.2792L40.8427 25.7223L37.5447 27.2792L40.8427 28.8361L42.8583 27.2792Z",
    fill: "#D8642D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2994 27.2741H36.9175L40.8781 25.4049L43.2994 27.2741Z",
    fill: "#FFF473"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2994 27.2745H36.9175L40.8781 29.1438L43.2994 27.2745Z",
    fill: "url(#paint19_linear_2038_666)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M43.2992 27.2741L40.8931 29.1333V25.4175L43.2992 27.2741Z",
    fill: "#D8642D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7799 27.1456L40.8479 25.42L41.0041 27.1456L43.2994 27.2741H36.9175L40.7799 27.1456Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2038_666",
    x1: 8.2075,
    y1: 27.5014,
    x2: 46.7055,
    y2: 27.5014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5B042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2038_666",
    x1: 44.9543,
    y1: 27.5012,
    x2: 10.8075,
    y2: 27.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2038_666",
    x1: 34.6771,
    y1: 23.1122,
    x2: 38.1861,
    y2: 16.4426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2038_666",
    x1: 17.7467,
    y1: 38.5038,
    x2: 20.5288,
    y2: 30.9151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2038_666",
    x1: 16.757,
    y1: 17.7527,
    x2: 24.3462,
    y2: 20.5358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2038_666",
    x1: 41.7156,
    y1: 41.7223,
    x2: 38.9221,
    y2: 34.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2038_666",
    x1: 26.4105,
    y1: 18.9092,
    x2: 31.2984,
    y2: 54.4347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5B042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2038_666",
    x1: 11.9958,
    y1: 27.499,
    x2: 43.0084,
    y2: 27.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000A94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2038_666",
    x1: 29.2068,
    y1: 28.8795,
    x2: 22.6991,
    y2: 22.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2038_666",
    x1: 32.28,
    y1: 18.418,
    x2: 42.5338,
    y2: 28.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2038_666",
    x1: 17.4297,
    y1: 29.0169,
    x2: 27.6399,
    y2: 39.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2038_666",
    x1: 42.9644,
    y1: 28.2621,
    x2: 30.1203,
    y2: 41.1061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2038_666",
    x1: 25.901,
    y1: 17.2165,
    x2: 15.6889,
    y2: 27.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2038_666",
    x1: 35.1077,
    y1: 32.856,
    x2: 31.6766,
    y2: 28.2371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2038_666",
    x1: 30.3639,
    y1: 29.4117,
    x2: 30.3335,
    y2: 21.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2038_666",
    x1: 25.6652,
    y1: 22.7342,
    x2: 30.3012,
    y2: 34.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5B042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2038_666",
    x1: 29.4698,
    y1: 19.2864,
    x2: 27.233,
    y2: 12.0889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2038_666",
    x1: 28.3812,
    y1: 42.1415,
    x2: 24.9831,
    y2: 34.8079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2038_666",
    x1: 13.0071,
    y1: 28.1688,
    x2: 20.341,
    y2: 24.7698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2038_666",
    x1: 41.9993,
    y1: 28.1688,
    x2: 34.6654,
    y2: 24.7698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FDAF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FEB44B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFBC38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF844"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.ae4a940cca5b7ab160b320045481cbb5.svg";
export { ForwardRef as ReactComponent };